module.exports = __webpack_public_path__ + "img/mkidn_color.4333fd04.jpg";